export const PERMISSION = 'PERMISSION';